/* eslint-disable import/prefer-default-export */
/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';

import Typography from '../../base/Typography';

export const DescriptionList = styled.dl`
${({ theme }) => css`
    margin: 0 0 0 1.5rem;
    padding:0 0 0 0.5rem;
  `}
`;

export const DescriptionListItems = styled.span`
${({ theme }) => css`
    display:flex
  `}
`;

export const DescriptionListTypography = styled(Typography)`
${({ theme }) => css`
    list-style-type: disc;
    display: list-item;
  `}
`;

export const DescriptionTerm = styled.dt`
${({ theme }) => css`
    display:inline;
  `}
`;

export const DescriptionDetails = styled.dd`
${({ theme }) => css`
    display:inline;
    margin:0;
  `}
`;
